module.exports = __webpack_public_path__ + "static/media/how_to_get_video_url.0fff0f30.pdf";